import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Select from "../common/Select";
import ReportsExpand from "../common/ReportsExpand";
import { getTeamClientsByProgramName } from "../services/soar";
import { getFieldName, getFieldText } from "../../scripts/helperScripts";

function OHParentPartnerReportClients({ isFavorite, toggleFavorite, ...rest }) {
  const [reportData, setReportData] = useState({
    Client: "",
  });
  const [clientOptions, setClientOptions] = useState([]);
  const [loading, setLoading] = useState({});
  const navigate = useNavigate();
  const isMountedRef = useRef(true);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const divisions = useMemo(() => {
    if (!safyInfo?.user?.divisions) {
      return [];
    }

    const OHDivisions = [
      "Canton",
      "Cincinnati",
      "Cleveland",
      "Columbus",
      "Dayton",
      "Findlay",
      "Lima Behavioral Health",
      "Sidney",
    ];

    return safyInfo.user.divisions.filter((div) => OHDivisions.includes(div));
  }, [safyInfo]);

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  const loadClients = async () => {
    setLoading(true);
    const response = await getTeamClientsByProgramName(
      divisions,
      "Parent Partner"
    );

    if (!isMountedRef.current) {
      return;
    }

    if (response) {
      const options = response.map((item) => ({
        _id: getFieldText(item.ccx_patient),
        name: getFieldName(item.ccx_patient),
      }));

      setClientOptions(options);
    }

    setLoading(false);
  };

  const handleChange = ({ currentTarget: input }) => {
    console.log("input: ", input, input.value);
    const data = { ...reportData };
    data[input.name] = input.value;
    setReportData(data);
  };

  return (
    <ReportsExpand
      title="Parent Partner Assessment Report"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      onExpand={loadClients}
      {...rest}
    >
      {!loading ? (
        <div className="row">
          <Select
            className="col-3"
            name="Client"
            label="Client"
            options={clientOptions}
            onChange={handleChange}
          />
          <div className="col-7"></div>
          {reportData.Client ? (
            <i
              className="fas fa-arrow-circle-right fa-3x col-2 float-end"
              onClick={() => {
                navigate("/OHParentPartnerReport", {
                  state: {
                    contact: clientOptions.filter(
                      (option) => option._id === reportData.Client
                    )[0],
                  },
                });
              }}
            ></i>
          ) : null}
        </div>
      ) : (
        <>Loading</>
      )}
    </ReportsExpand>
  );
}

export default OHParentPartnerReportClients;
